<template>
  <modalForm :title="$t('customers.createConversation')" :submit-label="$t('actions.send')" v-on:submit-event="onSubmit" v-on:cancel-event="cancel">
    <div v-if="error" class="text-red-600 text-sm font-bold mt-1 mb-1">{{ error }}</div>
    <div class="mt-4">
      <p class="block text-sm font-medium text-gray-700 mb-1">{{ $t('customers.template') }}:</p>
      <div class="border border-gray-300 border-b-0 whitespace-pre-line break-words  max-h-64 overflow-y-scroll scrollbar-thin scrollbar-thumb-indigo-300 scrollbar-track-indigo-50">
        <div v-for="message of whatsappMessages" v-bind:key="message.id" class="border-b border-gray-300 hover:bg-indigo-200">
          <WhatsappTemplateMessage :current="template" :message="message" v-on:template-selected="setTemplate" />
        </div>
      </div>
      <div v-for="error of v$.template.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ error.$message }}</div>
      </div>
    </div>
    <div class="mt-4">
      <input type="checkbox" name="agreement" id="agreement" v-model="agreement" class="focus:ring-indigo-500 focus:border-indigo-500 inline-block mr-2 border border-gray-300 p-2 rounded-md shadow-sm sm:text-sm ">
      <label for="agreement" class="inline text-sm font-medium text-gray-700 mb-1 cursor-pointer" style="white-space: initial;">{{ $t('customers.agreement') }}</label>
      <div v-for="error of v$.agreement.$errors" :key="error.$uid">
        <div class="text-red-600 text-sm mt-1 mb-2">{{ $t('customers.required') }}</div>
      </div>
    </div>
  </modalForm>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { required, sameAs } from '@vuelidate/validators'
import modalForm from '../building_blocks/modalForm'
import formViewMixin from '../building_blocks/formViewMixin'
import conversationModel from '@/models/conversation'
import WhatsappTemplateMessage from "../conversations/parts/WhatsappTemplateMessage";
import { useWhatsappMessagesStore } from '@/stores/whatsappMessageTemplates';


export default {
  mixins: [formViewMixin],
  name: 'ConversationCreate',
  props: ['customer', 'integration'],
  emits: ['create-finished-event'],
  setup () {
    let whatsappMessagesStore = useWhatsappMessagesStore();
    return { v$: useVuelidate(), whatsappMessagesStore };
  },
  components: {
    modalForm,
    WhatsappTemplateMessage,
  },
  computed: {
    whatsappMessages() {
      return this.whatsappMessagesStore.activeTemplates();
    },
  },
  methods: {
    async onFormValid() {
      let response;
      let conversationData = conversationModel.buildCreate(this.integration.attributes['phone-number'], this.customer.id, this.template.id);
      try {
        response = await conversationModel.createConversation(conversationData, this.axios, this.$root.token);
      } catch(error) {
        this.error = this.$t('customers.errorCreatingConversation');
      }
      if (response && response.status === 201) {
        this.error = '';
        this.$emit('create-finished-event');
      }
    },
    cancel() {
      this.$emit('create-finished-event');
    },
    setTemplate(template) {
      this.template = template;
    }
  },
  data() {
    return {
      'template': '',
      'agreement': false,
      'error': '',
    }
  },
  validations () {
    return {
      'template': { required },
      'agreement': { required, isTrue: sameAs(true) },
    }
  }
}
</script>
